labels:
  yourAppointment: Jouw afspraak
  treatment: Behandeling
  user: Medewerker
  date: Datum
  time: Tijd
  comment: Opmerkingen
fields:
  comment: Opmerkingen
messages:
  healthDeclarationAgreement:
    title: Jouw gezondheidsverklaring
    confirmText: Je bent akkoord gegaan met deze gezondheidsverklaring
  preparationAgreement:
    title: Jouw voorbereidingsinstructies
    confirmText: Je bent akkoord gegaan met deze voorbereidingsinstructies
